/// <amd-module name="Repos/PullRequest/Attachments/TelemetryConstants" />
export class PullRequestAttachmentTelemetryConstants {
    public static Area: string = "PullRequestAttachment";
    // Features
    public static RepoPROldImageUpdated = "RepoPROldImageUpdated";
    public static RepoPRAttachmentCreationFailed = "RepoPRAttachmentCreationFailed";
}
